import React, { Component } from "react";
import ArenaDataService from "../services/arena.service";
import { Link } from "react-router-dom";
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

const stateMap = {
  "AC": "Acre", "AL": "Alagoas", "AP": "Amapá", "AM": "Amazonas", "BA": "Bahia",
  "CE": "Ceará", "DF": "Distrito Federal", "ES": "Espírito Santo", "GO": "Goiás",
  "MA": "Maranhão", "MT": "Mato Grosso", "MS": "Mato Grosso do Sul", "MG": "Minas Gerais",
  "PA": "Pará", "PB": "Paraíba", "PR": "Paraná", "PE": "Pernambuco", "PI": "Piauí",
  "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte", "RS": "Rio Grande do Sul",
  "RO": "Rondônia", "RR": "Roraima", "SC": "Santa Catarina", "SP": "São Paulo",
  "SE": "Sergipe", "TO": "Tocantins"
};

export default class ArenasList extends Component {
  constructor(props) {
    super(props);
    this.retrieveArenas = this.retrieveArenas.bind(this);
    this.onChangeState = this.onChangeState.bind(this);

    // Recupera o estado salvo ou usa "Todos"
    const savedState = localStorage.getItem('arenaFilterState');

    this.state = {
      arenas: [],
      availableStates: [],
      selectedState: savedState || "Todos",
      isLoading: true,
    };
  }

  componentDidMount() {
    this.retrieveArenas();
  }

  onChangeState(e) {
    const selected = e.target.value;
    localStorage.setItem('arenaFilterState', selected); // Salva a escolha
    this.setState({
      selectedState: selected
    });
  }

  retrieveArenas() {
    ArenaDataService.getAll()
      .then(response => {
        const arenas = response.data;
        const uniqueStates = [...new Set(arenas.map(arena => arena.state))].sort();

        this.setState({
          arenas: arenas,
          availableStates: uniqueStates,
          isLoading: false,
        });
      })
      .catch(e => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  render() {
    const { arenas, availableStates, selectedState, isLoading } = this.state;

    const filteredArenas = selectedState === "Todos"
      ? arenas
      : arenas.filter(arena => arena.state === selectedState);

    return (
      <div className="mt-4">
        <Row className="align-items-center mb-4">
          <Col xs={12} md={8}>
            <h4>Arenas</h4>
          </Col>
          <Col xs={12} md={4}>
            <Form.Group controlId="state-select">
              <Form.Label>Estado</Form.Label>
              <Form.Select
                value={selectedState}
                onChange={this.onChangeState}
                className="date-select"
              >
                <option value="Todos">Todos os Estados</option>
                {availableStates.map((stateAbbr, index) => (
                  <option key={index} value={stateAbbr}>
                    {stateMap[stateAbbr] || stateAbbr}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        {isLoading ? (
          <div className="text-center">
            <img src="/images/loading.svg" alt="Carregando..." />
          </div>
        ) : (
          <Row>
            {filteredArenas.length > 0 ? (
              filteredArenas.map((arena, index) => (
                <Col key={index} className="col-12 col-md-6 col-lg-4 pb-4">
                  <Link to={`/arenas/${arena.arenaId}/${arena.arenaName}`}>
                    <Card className="flex-fill">
                      <Card.Body>
                        <Card.Title>{arena.arenaName}</Card.Title>
                        <Card.Subtitle className="mb-3 mt-3 arena-logo">
                          <img src={`/logos/${arena.arenaId}/logo.svg`} alt={`${arena.arenaName} Logo`} height="105" />
                        </Card.Subtitle>
                        <div className="card-text">
                          <div>Cidade: <span>{arena.city} - {arena.state}</span></div>
                          <div>Bairro: <span>{arena.district}</span></div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>
              ))
            ) : (
              <Col className="text-center">
                <p>Nenhuma arena encontrada neste estado.</p>
              </Col>
            )}
          </Row>
        )}
      </div>
    );
  }
}